import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-mortarPenetration",
  "use": "icon-mortarPenetration-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mortarPenetration\"><path d=\"M512 170.667a341.333 341.333 0 100 682.666 341.333 341.333 0 000-682.666zM85.333 512C85.333 276.352 276.352 85.333 512 85.333S938.667 276.352 938.667 512 747.648 938.667 512 938.667 85.333 747.648 85.333 512z\" /><path d=\"M475.05 874.667a42.667 42.667 0 0073.9 0l295.594-512a42.667 42.667 0 00-36.95-64H216.406a42.667 42.667 0 00-36.949 64l295.595 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol